import script from "./CPSPModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CPSPModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__

/* vue-cli-plugin-import-components */

import FormElement from "@/components/neue/FormElement.vue";
import FormSection from "@/components/neue/FormSection.vue";
import FranchiseLockNotice from "@/components/franchise/FranchiseLockNotice.vue";
import InputField from "@/components/neue/InputField.vue";
import NeueButton from "@/components/neue/NeueButton.vue";
import NeueToggle from "@/components/neue/NeueToggle.vue";
import SelectInput from "@/components/neue/SelectInput.vue";
import TheModal from "@/components/TheModal.vue";
script.components = Object.assign({}, { FormElement, FormSection, FranchiseLockNotice, InputField, NeueButton, NeueToggle, SelectInput, TheModal }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { FormElement, FormSection, FranchiseLockNotice, InputField, NeueButton, NeueToggle, SelectInput, TheModal }, script.__o.components);}